import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'select',
        name: 'fault_movements_type',
        title: 'Hareket Tipi',
        rules: {required: true},
        options: {
            data: [],
            label: 'name',
            track: 'id',
        },
        modal: ['status_id'],
        data: ['status_id',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        connectField: "fault_movements_type",
        connectFieldKey: ['key'],
        connectFieldValue: ['PROC'],
        name: 'serialNumber',
        title: 'Gelen Cihaz Seri No',
        rules: {required: true},
        modal: ['old_device_arrive', 'serial_no'],
        data: ['product_serial_number'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'users',
        title: 'İlgili Personel',
        rules: {required: true},
        options: {
            data: [],
            label: 'username',
            track: 'id',
            search: true
        },
        modal: ['user_id'],
        data: ['user_id',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'radio',
        name: 'didReach',
        connectField: 'fault_movements_type',
        connectFieldKey: ['key'],
        connectFieldValue: ['CHNG'],
        title: 'Cihaz Nerede ?',
        rules: {required: true},
        options: {
            locale: true,
            data: [
                {text: 'Müşteride', value: false},
                {text: 'Bizde', value: true},
            ],
            label: 'text',
            track: 'value'
        },
        modal: ['change_device', 'did_reach'],
        data: ['change_device', 'did_reach'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'nSerialNo',
        connectField: 'fault_movements_type',
        connectFieldKey: ['key'],
        connectFieldValue: ['CHNG'],
        title: 'Yeni Seri No',
        rules: {required: true},
       
        modal: ['change_device', 'new_serial_no'],
        data: ['change_device', 'new_serial_no'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'textarea',
        name: 'desc',
        title: 'Açıklama',
        rules: {required: false},
        modal: ['description'],
        data: ['description'],
        additionalButton: false,
        checkBox: false
    },
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/ERP/Stock/forms/faultMovement.js